var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"magazine-logo",attrs:{"href":`https://dundle.com/magazine/${this.$locale.language}`,"aria-label":"Dundle Magazine"}},[_c('nuxt-resource',{attrs:{"src":"images/themes/logos/dundle.com-2023/magazine/dundle-logo-magazine-light-theme.svg","alt":"Dundle Magazine logo","lazy":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }